import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  deleteScoreSettings,
  fetchCriteriaSettings,
  fetchScoreSettings,
  reorderScoreSettings,
  saveCriteriaSettings,
  saveScoreSettings,
} from '../routines/healthRoutines';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import { LEVEL_ID_MAP } from '../../common/constants/CommonConstants';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import { HEALTH_SCOPES_IDS } from '../../pages/HealthManagement/HealthManagementConstants';

const HEALTH_MANAGEMENT_BASE_URL = `${envConfig.APIG_URL}health-management`;

function* fetchScoreSettingsSaga(action) {
  try {
    const { level } = action.payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/score-settings?level=${level}`;
    const response = yield call(request, url);
    yield put(
      fetchScoreSettings.success({
        level,
        scoreSettings: response.data,
      })
    );
  } catch (error) {
    yield put(fetchScoreSettings.failure({ error }));
  }
}

function* fetchCriteriaSettingsSaga(action) {
  try {
    const { level } = action.payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/rag-status?level=${level}`;
    const response = yield call(request, url);
    yield put(
      fetchCriteriaSettings.success({
        level,
        criteriaSettings: response.data,
      })
    );
  } catch (error) {
    yield put(fetchCriteriaSettings.failure({ error }));
  }
}

function* saveScoreSettingsSaga({ payload }) {
  try {
    const { level, settings, scope, scopeReferenceId } = payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/score-settings`;
    const config = {
      method: 'POST',
      payload: {
        scope: HEALTH_SCOPES_IDS[scope],
        scopeReferenceId,
        entityLevelId: LEVEL_ID_MAP[level],
        ...settings,
      },
    };
    yield call(request, url, config);
    yield put(
      saveScoreSettings.success({
        successMessage: SUCCESS_MESSAGES.UPDATE_HEALTH_SCORE,
      })
    );

    yield call(fetchScoreSettingsSaga, { payload: { level } });
  } catch (error) {
    yield put(saveScoreSettings.failure({ error }));
  }
}

function* reorderScoreSettingsSaga({ payload }) {
  try {
    const { scoreId, reorderTo, level } = payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/score-settings/${scoreId}/reorder`;
    const config = {
      method: 'POST',
      payload: {
        entityLevel: level,
        reorderTo,
      },
    };
    yield call(request, url, config);
    yield put(reorderScoreSettings.success(payload));

    yield call(fetchScoreSettingsSaga, { payload: { level } });
  } catch (error) {
    yield put(saveScoreSettings.failure({ error }));
  }
}

function* deleteScoreSettingsSaga({ payload }) {
  try {
    const { scoreId, level } = payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/score-settings/${scoreId}`;
    const config = {
      method: 'DELETE',
    };
    yield call(request, url, config);
    yield put(deleteScoreSettings.success(payload));

    yield call(fetchScoreSettingsSaga, { payload: { level } });
  } catch (error) {
    yield put(saveScoreSettings.failure({ error }));
  }
}

function* saveCriteriaSettingsSaga(action) {
  try {
    const { level, settings } = action.payload;
    const url = `${HEALTH_MANAGEMENT_BASE_URL}/rag-status`;
    const config = {
      method: 'POST',
      payload: {
        scope: 1, // global
        entityLevelId: LEVEL_ID_MAP[level],
        config: settings,
      },
    };
    yield call(request, url, config);
    yield put(
      saveCriteriaSettings.success({
        successMessage: 'Successfully saved RAG criteria settings.',
      })
    );

    yield call(fetchCriteriaSettingsSaga, { payload: { level } });
  } catch (error) {
    yield put(saveCriteriaSettings.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchScoreSettings.TRIGGER, fetchScoreSettingsSaga),
    takeLatest(saveScoreSettings.TRIGGER, saveScoreSettingsSaga),
    takeLatest(reorderScoreSettings.TRIGGER, reorderScoreSettingsSaga),
    takeLatest(deleteScoreSettings.TRIGGER, deleteScoreSettingsSaga),
    takeLatest(fetchCriteriaSettings.TRIGGER, fetchCriteriaSettingsSaga),
    takeLatest(saveCriteriaSettings.TRIGGER, saveCriteriaSettingsSaga),
  ]);
}
